import React from "react"
import { Link } from "gatsby"

export const Ruta = ({ title, rutaTitle, classTitle, subRuta }) => {
  return (
    <>
      <div
        className={`ruta-container-${classTitle}`}
        data-sal="slide-up"
        data-sal-delay="300"
        data-sal-easing="ease"
      >
        <Link to="/">Inicio /</Link>{" "}
        {subRuta ? <Link to="/">{`${subRuta}`} / </Link> : null}
        <span>{rutaTitle}</span>
      </div>
      <div
        className={`${classTitle}-title-container`}
        data-sal="slide-up"
        data-sal-delay="400"
        data-sal-easing="ease"
      >
        <h1>
          {title[0]}
          <span>{" " + title[1]}</span>
        </h1>
      </div>
    </>
  )
}
